/*********************************************************************************
 * Copyright (C) 2025 VECROS Technologies Pvt. Ltd.
 * <legal@vecros.com>
 * This file is part of VECROS CLOUD SOFTWARE SERVICES maintained and developed by VECROS TECHNOLOGIES PRIVATE LIMITED.
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 **********************************************************************************/

import { useMediaQuery } from "@mui/material";
import { createContext, useContext, useEffect, useState } from "react";

const ThemeContext = createContext();
const STORAGE_KEY = "preferredTheme";

/**
 * Theme preference is stored locally. It previously round-tripped through the
 * legacy accounts Lambda on every toggle; vecros-api exposes no user-preference
 * endpoint, and a display preference does not warrant a network call.
 */
export const ThemeProviderContext = ({ children }) => {
  const systemPrefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");
  const [themeMode, setThemeMode] = useState(() => {
    const stored = localStorage.getItem(STORAGE_KEY);
    return stored ? stored === "dark" : systemPrefersDarkMode;
  });

  // Follow the system setting until the user expresses a preference.
  useEffect(() => {
    if (!localStorage.getItem(STORAGE_KEY)) setThemeMode(systemPrefersDarkMode);
  }, [systemPrefersDarkMode]);

  const toggleTheme = () => {
    setThemeMode((prevMode) => {
      const newMode = !prevMode;
      localStorage.setItem(STORAGE_KEY, newMode ? "dark" : "light");
      return newMode;
    });
  };

  return (
    <ThemeContext.Provider value={{ themeMode, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

export const useThemeContext = () => useContext(ThemeContext);
